interface Props {
  value: boolean;
  onChange?(value: boolean): void;
  loading: boolean;
}

const Toggle: React.FC<Props> = ({ value, loading, onChange }) => {
  return (
    <div
      className={`relative h-6 rounded-full   w-9 ${value ? "bg-pkc-primary" : "bg-pkc-secondary"}`}
      onClick={() => onChange?.(!value)}
      id="toggleIcon"
    >
      <div className={`absolute top-0 left-0 flex items-center w-full  h-full `}>
        <div
          className={`flex justify-center items-center transition-all rounded-full  ${
            value ? "bg-pkc-white" : "bg-pkc-white"
          }`}
          style={{ marginRight: value ? 3 : 14, width: 18, height: 18 }}
        >
          {loading && <i className="fa fa-spinner animate-spin" />}
        </div>
      </div>
    </div>
  );
};

export default Toggle;
